"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frameLoader = void 0;
const frameBaseLoader_1 = require("../../appLoaders/frameBaseLoader");
const frameLoader = params => {
    (0, frameBaseLoader_1.frameLoaderBase)(params);
};
exports.frameLoader = frameLoader;
//# sourceMappingURL=frameLoader.js.map